import { ITEMS_PER_PAGE } from "../../config/pagination.constants";


interface IQueryModel {
    pageOffset: number;
    pageSize: number;
    sortBy:string;
    sortOrder: string;
    search: string;
    searchType?: string;
    programId?: number;
}

export class QueryModel implements IQueryModel{
    pageOffset: number = 0; 
    pageSize: number = ITEMS_PER_PAGE;
    sortBy:string = 'id';
    sortOrder: string = 'desc';
    search: string = '';
    searchType: string ='';
    programId?: number;
    constructor(pageOff:number, size:number, sortby:string ='id', sortOder:string ='desc') {
        this.pageOffset = pageOff;
        this.pageSize = size;
        this.sortBy = sortby;
        this.sortOrder = sortOder;
    }
}